<template>
    <v-form
        v-model="valid"
        lazy-validation
        :disabled="isFetch"
    >
        <v-row>
            <v-col cols="6">
                <v-text-field
                        v-model="form.email"
                        label="Электронная почта"
                        :error-messages="errorMessages.email"
                        required
                ></v-text-field>
            </v-col>
            <v-col cols="6">
                <v-text-field
                        v-model="form.phone"
                        label="Телефон"
                        :error-messages="errorMessages.phone"
                        required
                ></v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="6">
                <v-checkbox
                        v-model="form.is_contact_primary"
                        label="Пометить контакт как основной"
                ></v-checkbox>
            </v-col>
            <v-col cols="6">
                <v-checkbox
                        v-model="form.is_jur_primary"
                        label="Пометить юридическую информацию как основную"
                ></v-checkbox>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-btn
                    :disabled="isFetch"
                    color="success"
                    class="mr-4"
                    @click="onSave"
                >
                    Сохранить
                </v-btn>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
    name: "ContactInfoForm",
    props:{
        initContactId: {
            type: Number,
            required: true
        },
    },
    data(){
        return {
            isFetch: false,
            valid: true,
            form: {
                email: '',
                phone: '',
                is_contact_primary: false,
                is_jur_primary: false,
            },
            errorMessages: {}
        }
    },
    methods:{
        ...mapActions('notifications', ['SHOW_SUCCESS', 'SHOW_ERROR', 'SHOW_RESPONSE_ERROR']),
        async onSave(){
            try {
                this.isFetch = true;
                let {data} = await this.getClient().addContactInfo(this.initContactId, this.form);
                this.$emit('added', data);
                this.SHOW_SUCCESS('Успешно создано');
                this.resetForm();
            }catch (e){
                this.SHOW_RESPONSE_ERROR({errorResponse: e, defaultError: 'Ошибка при создании контакта ('});
                if(e.response && e.response.data && e.response.data.errors){
                    this.setErrorMessages(e.response.data.errors);
                }
            }finally {
                this.isFetch = false;
            }
        },
        resetForm(){
            this.form.email = '';
            this.form.phone = '';
            this.form.is_contact_primary = false;
            this.form.is_jur_primary = false;
        },
        setErrorMessages(errorMessages){
            this.errorMessages = Object.assign({}, {}, errorMessages);
        },
    },
    computed: {
        ...mapGetters( 'contragents', ['getClient'])
    }
}
</script>

<style scoped>

</style>